import React from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker, Checkbox, Modal} from 'antd'
import { checkMoreThanLess, changeFormatdate } from '../../../utils/formatdate'
import moment from 'moment'

const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input

class DelegateFormModal extends React.PureComponent {

    state = {
        preLoadSubmitModal:false
    }

    handleSubmitFormModal = async (e) => {
        const { form, createDelegate } = this.props
        
        e.preventDefault()
        await this.setState({
            preLoadSubmitModal: true
        })

        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    createDelegate(values)
                    await this.setState({
                        preLoadSubmitModal: false
                    })
                }catch (error) {
                    await this.setState({
                        preLoadSubmitModal: false
                    })
                }
			}else{
                await this.setState({
                    preLoadSubmitModal: false
                })
            }
		})
    }

    handleSubmitFormModalReject = async (e) => {
        const { form, rejectDelegate } = this.props
        
        e.preventDefault()
        await this.setState({
            preLoadSubmitModal: true
        })

        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    rejectDelegate(values)
                    await this.setState({
                        preLoadSubmitModal: false
                    })
                }catch (error) {
                    await this.setState({
                        preLoadSubmitModal: false
                    })
                }
			}else{
                await this.setState({
                    preLoadSubmitModal: false
                })
            }
		})
    }

    disabledDate = (current) =>{
        const { disabledDateStart } = this.state
        return current && current < disabledDateStart;
    }

    closeModal = async () =>{
        const { closeModal } = this.props

        closeModal('')
    }

    onChangeValueDateStart = async (e) =>{

		const { endStartValues } = this.state

      if(e){
         await this.setState({
            disabledDateStart: moment(e),
        })
  
        let checkDatemore = checkMoreThanLess(e, endStartValues)
  
        if(checkDatemore){
           await this.props.form.setFieldsValue({
              endDate: checkDatemore,
           })
  
           await this.setState({
              endStartValues: checkDatemore
           })
        }
      }else{
         await this.setState({
            disabledDateStart:null
        })

        await this.props.form.setFieldsValue({
            endDate: null,
         })
      }
		
	}

    onChangeValueDateEnd = async (e) =>{
		await this.setState({
			endStartValues: moment(e),
		})
	}

   disabledDateWD = (current) =>{
      return current && current < moment().add(-1,'day');
    }

	async componentDidMount() {
    }

    async componentDidUpdate(prevProps) {
        if(!prevProps.visibleModal){
            // console.log
            this.props.form.resetFields();
            await this.setState({
                disabledDateStart: null,
                endStartValues: null,
            })
        }
    }

    dateFormatNumber = (values) =>{
      let valueReturn = this.props.form.getFieldValue(values)
      return changeFormatdate(moment(valueReturn))
  }

	render() {
        const { disabledDateStart, endStartValues } = this.state
		const { detail, title, preLoadSubmitModal, visibleModal, modalFormPage, dropdownlistDelegator, dataProfile } = this.props
		const { getFieldDecorator } = this.props.form;

      console.log('endStartValues',endStartValues)
      console.log('disabledDateStart',disabledDateStart)

        return (
			<>
				<Modal
					visible={visibleModal}
					title={(
						<>
                            <strong className="color-red">
                                {/* { title } */}
                                
                                { modalFormPage == 'createDelegate' ? 'เพิ่มมอบอำนาจการอนุมัติ' : 'ยืนยันการยกเลิกการมอบอำนาจ' }
                            </strong>
						</>
					)}
					onOk={
						() =>{
							// window.location.reload();
						}
					}
					onCancel={
						() =>{
                            this.closeModal()
							// window.location.reload();
						}
					}
					width={600}
					footer={null}
               className="showTextArrea"
                >   
                    {
                        modalFormPage == 'createDelegate' ? 
                            <>
                                <Form onSubmit={this.handleSubmitFormModal}>
                                    <Row gutter={16} type="flex" justify="left" align="top" >
                                    <Col xs={ 24 } md={12}>
                                            <Form.Item label="วันที่เริ่มต้น" className="mb-0">
                                                { getFieldDecorator('startDate', {
                                                    initialValue: disabledDateStart,
                                                    rules:  [{ 
                                                        required: true, 
                                                        message: 'กรุณาเลือก วันที่เริ่มต้น',
                                                    }],
                                                })(
                                                    <DatePicker 
                                                         disabledDate={ this.disabledDateWD }
                                                        className="w-100"  
                                                        placeholder="เลือกวันที่" 
                                                        onChange={(e) => this.onChangeValueDateStart(e)}
                                                        allowClear={false}
                                                        format={this.dateFormatNumber("startDate")} 

                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        
                                        <Col xs={ 24 } md={12}>
                                            <Form.Item label="วันที่สิ้นสุด" className="mb-0">
                                                { getFieldDecorator('endDate', {
                                                    initialValue: endStartValues,
                                                    rules:  [{ 
                                                        required:true,
                                                        message: 'กรุณาเลือก วันที่สิ้นสุด',
                                                    }],
                                                })(
                                                    <DatePicker 
                                                        disabledDate={this.disabledDate} 
                                                        className="w-100" 
                                                        // defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                                                        placeholder="เลือกวันที่"
                                                        onChange={(e) => this.onChangeValueDateEnd(e)}
                                                        disabled={ disabledDateStart ? false : true }
                                                        allowClear={false}
                                                        format={this.dateFormatNumber("endDate")} 
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>

                                        <Col xs={ 24 } md={24}>
                                            <Form.Item label={"ชื่อผู้รับมอบอำนาจ"}>
                                                { this.props.form.getFieldDecorator("toEmpCode", {
                                                    initialValue: "",
                                                    rules:  [{ 
                                                        required:true, 
                                                        message: 'กรุณาเลือกผู้รับมอบอำนาจ',
                                                    }],
                                                })(
                                                    <Select 
                                                        style={{ width: "100%" }}
                                                        showSearch
                                                        placeholder=""
                                                        optionFilterProp="children"
                                                    >
                                                        {
                                                            dropdownlistDelegator.length !== 0 ? 
                                                                dropdownlistDelegator.map((valuseLabel, keysLabel) =>{
                                                                    return <Option value={valuseLabel.empCode}>{ valuseLabel.fullName }</Option>
                                                                })
                                                            : ''
                                                        }
                                                    </Select>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={ 24 } md={12}>
                                            {/* <Form.Item label={"ประเภทการมอบอำนาจ"}>
                                                { this.props.form.getFieldDecorator("docType", {
                                                    initialValue: "",
                                                    rules:  [{ 
                                                        required:true, 
                                                        message: 'กรุณาเลือกการมอบอำนาจ',
                                                    }],
                                                })(
                                                    <Checkbox.Group style={{ width: '100%' }}>
                                                        <Checkbox className="mr-3" value="MEDICAL"/>ค่ารักษาพยาบาล<br />
                                                        <Checkbox className="mr-3" value="LEAVE"/>การลา
                                                    </Checkbox.Group>
                                                )}
                                            </Form.Item> */}
                                        </Col>
                                        
                                        {
                                            detail &&
                                            <Col xs={ 24 } md={24} className="mt-4">
                                                <label>{"สถานะ: "+detail.status}</label>
                                                {/* <Form.Item label={"สถานะ: "+detail.status} className="mb-0"></Form.Item> */}
                                            </Col>
                                        }
                                        <Col xs={24} md={24} align={"right"} className="mt-4">
                                            <Button 
                                                type="primary" 
                                                className="mx-2 btn-white-red btn-custom-create"  
                                                onClick={this.closeModal}
                                            >
                                                ยกเลิก
                                            </Button>
                                            <Button 
                                                type="primary" 
                                                id="btn-onsearch" 
                                                className="ml-2 color-white btn-custom-create" 
                                                htmlType="submit" 
                                                disabled={preLoadSubmitModal}
                                            >
                                                ตกลง
                                            </Button>
                                            {
                                                preLoadSubmitModal &&
                                                <Spin size="small" />
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </>
                            :
                            <>
                                <Form onSubmit={this.handleSubmitFormModalReject}>
                                    <Row gutter={16} type="flex" justify="left" align="top" >
                                        <Col xs={ 24 } md={24}>
                                            <Form.Item label={"เหตุผลที่จะยกเลิกการมอบอำนาจ"}>
                                                { this.props.form.getFieldDecorator("note", {
                                                    initialValue: "",
                                                    rules:  [{ 
                                                        required: true, 
                                                        message: 'กรุณากรอกเหตุผลที่จะยกเลิกการมอบอำนาจ',
                                                    }],
                                                })(
                                                    <TextArea rows={4} style={{ width:"100%" }}/>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={24} align={"right"} className="mt-2">
                                            <Button 
                                                type="primary" 
                                                className="mx-2 btn-white-red btn-custom-create"  
                                                onClick={this.closeModal}
                                            >
                                                ยกเลิก
                                            </Button>
                                             <Button 
                                                   type="primary" 
                                                   id="btn-onsearch" 
                                                   className="ml-2 btn-custom-create color-white" 
                                                   htmlType="submit" 
                                                   disabled={preLoadSubmitModal}
                                             >
                                                   ตกลง
                                             </Button>
                                            {
                                                preLoadSubmitModal &&
                                                <Spin size="small" />
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </>
                        }
                </Modal>
			</>
		)
	}
}

DelegateFormModal.defaultProps = {
	autoFocus: false
}

DelegateFormModal.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedDelegateFormModal = Form.create()(DelegateFormModal)

export default withApollo(WrappedDelegateFormModal)